"use client";

import { Combobox, Field, ImageUpload, Input, Select, Textarea } from "./ui";
import { CURRENCIES } from "@/lib/invoice/utils";
import { currencyOptions, taxModeOptions } from "./options";
import { AddressFields } from "./AddressFields";
import { templateOptions } from "@/lib/invoice/templates";

export const CLIENT_BLANK = {
  name: "", contactPerson: "", email: "", ccEmail: "", phone: "", whatsapp: "", address: "", area: "", city: "", state: "", postcode: "", country: "",
  gstin: "", pan: "", currency: "", taxMode: "", dueDays: "", brandId: "", template: "", logo: "", notes: "", archived: false,
};

export function ClientForm({ value, onChange, brands = [] }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      <Field label="Client / company name *" className="sm:col-span-2">
        <Input value={value.name} onChange={set("name")} autoFocus />
      </Field>
      <Field label="Contact person"><Input value={value.contactPerson} onChange={set("contactPerson")} /></Field>
      <Field label="Email (invoices sent to)"><Input type="email" value={value.email} onChange={set("email")} /></Field>
      <Field label="CC email (accounts team)"><Input type="email" value={value.ccEmail} onChange={set("ccEmail")} /></Field>
      <Field label="Mobile / phone"><Input value={value.phone} onChange={set("phone")} /></Field>
      <Field label="WhatsApp number" hint="With country code, e.g. 447700900123"><Input value={value.whatsapp} onChange={set("whatsapp")} /></Field>
      <Field label="Tax ID (GSTIN / VAT / EIN…)"><Input value={value.gstin} onChange={set("gstin")} /></Field>
      <AddressFields value={value} onChange={onChange} autoCurrency />
      <Field label="PAN"><Input value={value.pan} onChange={set("pan")} /></Field>

      <div className="mt-2 border-t border-slate-100 pt-3 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2">Billing defaults</div>
      <Field label="Currency">
        <Combobox
          strict
          value={value.currency || ""}
          onChange={(currency) => onChange({ ...value, currency: CURRENCIES[currency] ? currency : "" })}
          options={[{ value: "", label: "App default" }, ...currencyOptions.map((o) => ({ value: o.value, label: o.label, hint: CURRENCIES[o.value].symbol.trim() }))]}
          placeholder="App default"
          testId="client-currency"
        />
      </Field>
      <Field label="Tax treatment">
        <Select value={value.taxMode} onChange={set("taxMode")} options={[{ value: "", label: "Automatic (from country/state)" }, ...taxModeOptions]} />
      </Field>
      <Field label="Payment terms (days)" hint="Blank = app default">
        <Input type="number" min={0} value={value.dueDays} onChange={set("dueDays")} />
      </Field>
      <Field label="Invoice as (business profile)">
        <Select value={value.brandId} onChange={set("brandId")}>
          <option value="">Default profile</option>
          {brands.map((b) => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </Select>
      </Field>
      <Field label="Invoice template">
        <Select value={value.template} onChange={set("template")} options={[{ value: "", label: "Profile default" }, ...templateOptions]} />
      </Field>

      <div className="mt-2 border-t border-slate-100 pt-3 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2">Client branding</div>
      <Field label="Client logo" hint="Shown in the Bill To block (co-branded invoices). Toggle per invoice." className="sm:col-span-2">
        <ImageUpload value={value.logo} onChange={(logo) => onChange({ ...value, logo })} />
      </Field>
      <Field label="Notes (internal)" className="sm:col-span-2"><Textarea value={value.notes} onChange={set("notes")} /></Field>
    </div>
  );
}
